import { _ as _define_property } from "@swc/helpers/_/_define_property";
import React from 'react';
import { connectMediaStore } from '../../_hocs/withOwnReduxStore';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { moveGallectionToPosition } from '../../actions';
import GallectionGrid from '../GallectionGrid';
import PopupInnerLayout from '../../_partials/PopupInnerLayout';
import FolderCard from '../../_partials/FolderCard';
import { isSpecialStuckGallection } from '../../helpers';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import GallectionControlButtons from '../../_partials/GallectionControlButtons';
import AddGallectionButton from '../../_partials/AddGallectionButton';
import withGallections from '../../_hocs/withGallections';
import withCurrentMediaSource from '../../_hocs/withCurrentMediaSource';
import { MediaSourceType } from '../../types';
import withGlobalPrivs from '../../_hocs/withGlobalPrivs';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
import gallectionManagerStyles from './GallectionManager.scss';
const enhance = compose(withGallections, withCurrentMediaSource, withGlobalPrivs, connectMediaStore(null, {
    moveGallectionToPosition
}), withTranslation());
export class GallectionManager extends React.Component {
    render() {
        return /*#__PURE__*/ React.createElement(PopupInnerLayout, {
            headerSubtitle: this.getSubtitle(),
            headerExtrasRightZone: /*#__PURE__*/ React.createElement(AddGallectionButton, null),
            scrollableContent: this.renderContent(),
            onScrolledToBottom: this.fetchMoreGallectionsIfNeeded,
            onNotScrollable: this.fetchMoreGallectionsIfNeeded
        });
    }
    getSubtitle() {
        const { t, currentMediaSource, canRearrangeGalleryFolders } = this.props;
        switch(currentMediaSource){
            case MediaSourceType.STASH:
                return t('mediapopup.editYourStashFoldersHint');
            case MediaSourceType.GALLERY:
                return canRearrangeGalleryFolders ? t('mediapopup.editYourGalleriesHint') : '';
            case MediaSourceType.PRIVATE_COLLECTION:
                return t('mediapopup.editYourPrivateCollectionsHint');
            case MediaSourceType.COLLECTION:
            default:
                return t('mediapopup.editYourCollectionsHint');
        }
    }
    renderContent() {
        const { isGallectionStreamInitialized, gallections, hasMoreGallections, moveGallectionToPosition: moveGallection } = this.props;
        this.existingGallectionNames = this.props.gallections.map((gallection)=>gallection.name);
        return /*#__PURE__*/ React.createElement(React.Fragment, null, isGallectionStreamInitialized && /*#__PURE__*/ React.createElement(GallectionGrid, {
            cookieType: MeasuredCookieType.GALLECTION_MANAGER,
            gallections: gallections,
            gallectionRenderer: this.renderGallection,
            moveGallectionToPosition: moveGallection
        }), hasMoreGallections && /*#__PURE__*/ React.createElement(LoadingIndicator, {
            view: "daSymbol",
            coverMode: !gallections.length && hasMoreGallections
        }));
    }
    constructor(...args){
        super(...args), _define_property(this, "existingGallectionNames", void 0), _define_property(this, "fetchMoreGallectionsIfNeeded", ()=>{
            const { hasMoreGallections, isFetchingGallections, fetchMoreGallections } = this.props;
            if (!hasMoreGallections || isFetchingGallections) {
                return;
            }
            fetchMoreGallections();
        }), _define_property(this, "renderGallection", ({ index, width })=>{
            const { gallections } = this.props;
            const gallection = gallections[index];
            const extras = /*#__PURE__*/ React.createElement(GallectionControlButtons, {
                gallection: gallection,
                existingGallectionNames: this.existingGallectionNames,
                className: gallectionManagerStyles['folder-card-controls'],
                moreMenuClassName: gallectionManagerStyles['folder-card-controls-menu']
            });
            return /*#__PURE__*/ React.createElement(FolderCard, {
                className: gallectionManagerStyles['folder-card'],
                width: width,
                folder: gallection,
                isLocked: isSpecialStuckGallection(gallection),
                extras: extras,
                withPrice: true
            });
        });
    }
}
export default enhance(GallectionManager);

//# sourceMappingURL=GallectionManager.js.map